import React from "react";
import "./BeliefBreak.css";

function BeliefBreak() {
  return (
    <section className="belief section">
      <div className="container belief__container">
        <div className="belief__top">
          <span className="belief__tag">
            📈 Lucro visível por porção
          </span>

          <h2>
            VEJA COMO UMA SOBREMESA
            <br />
            DE BAIXO CUSTO PODE VIRAR
            <br />
            UMA NOVA <span>FONTE DE LUCRO.</span>
          </h2>

          <p>
            Com um custo médio de R$ 52 por kg e rendimento aproximado
            de 40 porções de 100g, o restaurante consegue trabalhar com
            um custo médio de apenas R$ 1,30 por porção.
          </p>
        </div>

        <div className="belief__cards">
          <div className="belief__card">
            <div className="belief__icon">💲</div>

            <strong>R$ 52/kg</strong>

            <span>Custo médio do produto</span>
          </div>

          <div className="belief__card">
            <div className="belief__icon">🍨</div>

            <strong>40 porções</strong>

            <span>Rendimento médio de porções de 100g</span>
          </div>

          <div className="belief__card belief__card--highlight">
            <div className="belief__icon belief__icon--white">💰</div>

            <strong>R$ 1,30</strong>

            <span>
              Custo médio por porção
              <br />
              para o restaurante
            </span>
          </div>
        </div>

        <div className="belief__machine-alert">
          <div className="belief__machine-icon">⚠️</div>

          <div>
            <strong>
              Para operação do frozen é necessário utilizar máquina soft.
            </strong>

            <p>
              Trabalhamos com opções de <span>locação</span> e também
              <span> venda da máquina</span>, facilitando a implementação
              no restaurante.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BeliefBreak;